










































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetGauge, PatientSearch, EditPatient } from "@/request/projects";
import { Form as elForm } from "element-ui";
@Component({})
export default class Patient extends Vue {
  private id: any = "";
  private data: any = {};
  private patients: any = [];
  private info: any = {
    姓名: "",
    性别: "",
    出生日期: "",
    认证方式: "",
    身份证号: "",
    电话: "",
  };
  private rules: any = {
    姓名: [{ required: true, message: "请填写姓名", trigger: "blur" }],
    性别: [{ required: true, message: "请选择性别", trigger: "blur" }],
    出生日期: [{ required: true, message: "请选择出生日期", trigger: "blur" }],
    认证方式: [{ required: true, message: " 请选择认证方式", trigger: "blur" }],
    身份证号: [{ required: true, message: "请填写认证号码", trigger: "blur" }],
    电话: [{ message: "请填写联系方式", trigger: "blur" }],
  };
  /**
   * @description 获取量表发布页面数据
   */
  private getSetting() {
    const params = {
      params: {
        template_id: this.id,
      },
    };
    GetGauge(this, params).then((res) => {
      this.data = res;
    });
  }
  /**
   * @description 确定提交
   */
  private makeSure() {
    (this.$refs.patientForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params = this.info;
        params.doctor_id = this.data.doctor_id;
        if (!params.patient_id) {
          params.project_id = this.data.project_id;
          params.group_id = this.data.group_id;
        }
        this.$router.push({
          path: "/share/gauge",
          query: {
            template_id: this.id,
            patient_id: this.info.patient_id,
          },
        });
        // EditPatient(this, params).then((res) => {
        //   console.log("创建成功");
        // });
      }
    });
  }
  /**
   * @description 姓名搜索
   */
  private searchName(e, cb) {
    const params = {
      project_id: this.data.project_id,
      group_id: this.data.group_id,
      姓名: e,
    };
    PatientSearch(this, params).then((res) => {
      this.patients = res;
    });
    setTimeout(() => {
      cb(this.patients);
    }, 1000);
  }
  private handleSelect(item) {
    this.info = item;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.template_id) {
      this.$message.error("量表不存在");
      this.$router.back();
      return;
    }
    this.id = this.$route.query.template_id;
    this.getSetting();
  }
}
